import { render, staticRenderFns } from "./UploadProgressBar.vue?vue&type=template&id=3bc078f0&scoped=true&"
import script from "./UploadProgressBar.vue?vue&type=script&lang=js&"
export * from "./UploadProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./UploadProgressBar.vue?vue&type=style&index=0&id=3bc078f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc078f0",
  null
  
)

export default component.exports